<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <allocation-control></allocation-control>
      <allocation-view></allocation-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AllocationControl from "@/components/allocations/allocationControl";
import AllocationView from "@/components/allocations/allocationView";

export default {
  components: {
    AllocationControl,
    AllocationView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
